<template>
  <div class="checkbox checkbox-custom">
    <BCheckbox
      v-for="(option,idx) in optionsAll"
      :id="id + '-' + idx"
      :key="idx"
      v-model="checked"
      :name="id"
      type="checkbox"
      :value="option.id"
      :class="classes"
    >
      {{option.name}}
      <span v-if="aria">{{aria}}</span>
    </BCheckbox>
  </div>
</template>

<script>
import map from 'lodash/map'
import filter from 'lodash/filter'

const _ = { map, filter }
export default {
  name: 'BaseCheckbox',
  props: {
    id: { type: String, required: true },
    value: { required: true },
    aria: { type: String, required: false, default: '' },
    options: { type: Array, required: true },
    asObject: { type: Boolean, default: false },
    innerClass: { type: [String, Object], default: '' },
    any: { type: [Boolean], default: false },
    anyName: { type: String, default: 'Dowolne' },
    error: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: [] //checked
    }
  },
  computed: {
    values: {
      set: function(v) {
        this.checked = _.map(v, val => (this.asObject ? val.id : val))
      },
      get: function() {
        let ret = _.filter(
          _.map(this.options, v =>
            this.checked.indexOf(v.id) != -1
              ? this.asObject
                ? v
                : v.id
              : false
          ),
          v => v
        )
        return ret
      }
    },
    optionsAll: function() {
      return this.any === true && this.options[0].id !== ''
        ? [{ id: '', name: this.anyName }, ...this.options]
        : this.options
    },
    hasError() {
      return this.error ? true : false
    },
    classes() {
      return {
        'is-invalid': this.hasError
      }
    }
  },
  watch: {
    value: function(newValue, oldValue) {
      let n = []
      if (typeof newValue == 'object' && newValue !== null) {
        newValue.forEach(v => n.push(v.id ? v.id : v))
        if (n.join('') !== this.checked.join('')) {
          this.values = newValue
        }
      } else if (newValue != oldValue) {
        this.values = [newValue]
      }
    },
    values: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        let v = newValue
        if (this.options.length > 1) {
          this.$emit('input', v)
        } else {
          this.$emit('input', v[0] ? v[0] : null)
        }
      }
    }
  },
  created() {
    this.values = typeof this.value == 'object' ? this.value : [this.value]
  }
}
</script>
 
<style lang="scss">
</style>
